import {  postRequest } from '@/libs/axios';

export const getChannel1List = (params) => {
    return postRequest('/ndt/module/mainOrder/page', params)
}

export const getChannel2List = (params) => {
    return postRequest('/ndt/module/box/page', params)
}

export const getChannel3List = (params) => {
    return postRequest('/ndt/order/pageOrder', params)
}

export const getChannel3List2 = (params) => {
    return postRequest('/ndt/module/box/order/page', params)
}
